export default __webpack_public_path__ + "static/media/medaille-qdo-or-realisation.e0749fc4.png";